// extracted by mini-css-extract-plugin
export var container = "styles-module--container--MfqOo";
export var containerTeaser = "styles-module--containerTeaser--PCw9m";
export var hl = "styles-module--hl--b1RW6";
export var img = "styles-module--img--sneLh";
export var subHeadline = "styles-module--subHeadline--63b2E";
export var wrapper = "styles-module--wrapper--Exl-T";